<template>
  <BadgeSize
    badge-rounded="rounded"
    color="primary"
    location="bottom right"
    :size="size"
  >
    <template #badge>
      <v-icon :size="iconSize">fas fa-user-group</v-icon>
    </template>

    <BadgeSize
      v-if="box"
      color="primary-lighten-3"
      :content="getBoxInboxCountText(box)"
      location="top right"
      :offset-y="-2"
      :size="18"
      :size-font="isInboxCountBiggerThen2Chars(box) ? 10 : 12"
      text-color="primary"
    >
      <BoxAvatarTypeIcon :box="box" :size="boxSize" />
    </BadgeSize>
  </BadgeSize>
</template>

<script setup lang="ts">
import { useBoxAvatar } from '@/composables/box/box-avatar'
import BoxAvatarTypeIcon from '@/components/box/BoxAvatarTypeIcon.vue'
import BadgeSize from '@/components/dashboard/BadgeSize.vue'
import type { BoxEntry } from '@deepcloud/api-deep-box'

defineProps({
  box: {
    type: Object as PropType<BoxEntry>,
    default: undefined,
  },
  size: {
    type: Number,
    default: 16,
  },
  avatarSize: {
    type: Number,
    default: 24,
  },
  iconSize: {
    type: Number,
    default: 8,
  },
  boxSize: {
    type: Number,
    default: 24,
  },
})

const { isInboxCountBiggerThen2Chars, getBoxInboxCountText } = useBoxAvatar()
</script>
